module.exports = __webpack_public_path__ + "img/pencil-no-shadow.8a6c0ce.png";